import {
    PROFILES_PATCH_FAILURE,
    PROFILES_PATCH_REQUEST,
    PROFILES_PATCH_SUCCESS,
} from 'actions';

const initialState = {
    patching: false,
    hasErrors: false,
};

export const profilePatchReducer = (state = initialState, action) => {
    const {type, profile} = action;
    switch (type) {
        case PROFILES_PATCH_SUCCESS: {return {
            ...initialState,
            profile,
        }}

        case PROFILES_PATCH_REQUEST: {return {
            ...initialState,
            patching: true,
        }}

        case PROFILES_PATCH_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: { return state }
    }
};
